import { UserService } from './../base-services/user.service';
import { ModelData } from './../base-models/model-data';
import { OnInit, OnDestroy, Optional, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ModelDataService } from '../base-services/model-data.service';

export class BaseComponent implements OnInit, OnDestroy {
    constructor(
        protected activatedRoute: ActivatedRoute,
        protected userService: UserService,
        @Optional() @Inject(ModelDataService) protected modelDataService?: ModelDataService
    ){}

    private _modelDataSubscription: Subscription;
    modelData: ModelData;
    routeName: string;
    public disabledDueToLoad: boolean = false;
    ngOnInit(){
        if(!this.routeName){
            this._modelDataSubscription = this.activatedRoute.data.subscribe(data => {
                this.modelData = new ModelData(this.userService).LoadModelData(data);
                this.OnModelDataLoaded();
            })
        }
        else if(this.routeName != null && this.modelDataService){
            this.modelData = this.modelDataService.GetModelDataByPath(this.routeName);
        }
    }

    ngOnDestroy(){
        if(this._modelDataSubscription != null)
            this._modelDataSubscription.unsubscribe();
    }

    OnModelDataLoaded(){

    }
}
